// SvgColorImg
//
// Create a div with a coloured mask (cf https://stackoverflow.com/a/56669846/9316077)
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
// Use imgColorAsCssFill to color images, to work around Samsung
// dark mode issues.
//
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
//
// Used to be:
//     Loads an svg as an img element. Display outside the viewable area,
//      and displays its colored shadow instead.
//     Displays the image also a second time, transparent, to properly set the containing
//      div dimensions
//
//     But image would not display when shadowed image was outside the display
//
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  useCallback,
  useEffect,
  useState,
} from 'react';

const SvgColorImg = function SvgColorImg(props) {
  const {
    description = '',
    src,
    imgColor,
    imgColorAsCssFill,
    style,
    className,
    // defaultDotDotDot = false,
    // defaultCone = false,
    missCallback,
    absolute = false,
    halo = false,
    outline = false,
  } = props;

  const [imageSrc, setImageSrc] = useState(src);

  const handleError = useCallback(
    () => {
      // let defaultSrc;
      // if (defaultDotDotDot) defaultSrc = '/images/svg/gui/dotdotdot.svg';
      // if (defaultCone) defaultSrc = '/images/svg/gui/cone.svg';
      const defaultSrc = '/images/svg/gui/squareCrossed.svg';

      // console.group(`SvgImg cannot find src=${src}`);
      setImageSrc(defaultSrc);
      if (missCallback) missCallback(src);
    },
    [
      // defaultCone, defaultDotDotDot,
      missCallback, src,
    ],
  );

  // Reflect src updates
  useEffect(
    () => { setImageSrc(src); },
    [src],
  );

  const divClassName = classNames(
    'overflow-hidden',
    {
      'relative': !absolute,
      absolute,
      'drop-shadow-halo': halo,
    },
    className,
  );

  // Load image, so the browser caches it and we know if it's missing
  useEffect(
    () => {
      const preloadImage = (url, onLoad, onError) => {
        const img = new Image();
        img.onload = onLoad;
        img.onerror = onError;
        img.src = url;
      };

      if (imgColor) {
        preloadImage(src, () => {}, handleError);
      }
    },
    [src, imgColor, handleError],
  );

  if (imgColorAsCssFill || imgColor) {
    const imgStyle = {
      ...(imgColor && { fill: imgColor }),
      ...(outline && {
        stroke: 'rgba(0,0,0, 0.75)',
        strokeWidth: 1,
        paintOrder: 'fill stroke',
        // paintOrder: 'stroke fill',
        strokeLinejoin: 'round',
      }),
    };
    const useClassName = classNames(
      'w-full h-full',
      { '[vector-effect:non-scaling-stroke]': outline },
    );

    return (
      <div
        style={style}
        className={divClassName}
      >
        <svg
          className="w-full h-full overflow-hidden"
          style={imgStyle}
          alt={description}
        >
          <use
            className={useClassName}
            xlinkHref={`${imageSrc}#img`}
            href={`${imageSrc}#img`}
          />
        </svg>
      </div>
    );
  }

  return (
    <div
      style={style}
      className={divClassName}
    >
      <img
        src={imageSrc}
        alt={description}
        className="w-full h-full"
        onError={handleError}
      />
    </div>
  );
};

SvgColorImg.propTypes = {
  description: PropTypes.string,
  src: PropTypes.string.isRequired,
  imgColor: PropTypes.string,
  // Set to color svg image based on the fill- attributes
  // the svg image top <svg> tag must contain a id="img" attribute
  imgColorAsCssFill: PropTypes.bool,
  style: PropTypes.shape({ }),
  className: PropTypes.string,
  defaultDotDotDot: PropTypes.bool,
  defaultCone: PropTypes.bool,
  missCallback: PropTypes.func,
  absolute: PropTypes.bool,
  halo: PropTypes.bool,
  outline: PropTypes.bool,
};

export default SvgColorImg;
